import { hasResumableInterviewSession } from '@/lib/interviewStorage'
import { fetchActiveInterview } from '@/lib/interviewType'

export const INTERVIEW_IN_PROGRESS_TITLE = 'Interview in Progress'

export const INTERVIEW_IN_PROGRESS_DESCRIPTION =
  'You already have an interview in progress in another tab or window. Please complete or submit the current interview, or close that tab, before starting a new one.'

const BLOCKING_SERVER_STATUSES = new Set(['In Progress'])

export function isBlockingServerInterviewStatus(
  status: string | null | undefined,
): boolean {
  return Boolean(status && BLOCKING_SERVER_STATUSES.has(status))
}

/**
 * True when the server has an In Progress interview but this tab cannot resume locally.
 * Covers duplicate /interview tabs and starting a different interview while one is active.
 * Temp Abandoned is intentionally excluded — user may start fresh after leaving a tab.
 */
export async function shouldBlockInterviewEntry(): Promise<boolean> {
  if (typeof window === 'undefined') return false
  if (hasResumableInterviewSession()) return false

  const active = await fetchActiveInterview()
  if (!active?.interview_id) return false

  return isBlockingServerInterviewStatus(active.status)
}

/** Normalize HTTP / API errors for "interview already in progress". */
export function isInterviewInProgressConflict(
  status: number | undefined,
  message?: string | null,
): boolean {
  if (status === 409) return true
  const normalized = (message ?? '').toLowerCase()
  return normalized.includes('interview in progress')
}
